import { freeSet } from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import Checkbox from "@material-ui/core/Checkbox";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import { CInput } from "@coreui/react";
import React, { useState, useEffect } from "react";
import { COLORS } from "../../constants/Colors";
import { toolTipContactDetails } from "../../functions/tooltips";
import { iStaffBaseURL } from "../../constants/Urls";
import axios from "axios";
import { notify } from "../../functions/function";
import { axiosTimeout } from "../../constants/Axios";

const EmployeeTableRow = ({ row, dispatch, labelId, userToken, employees }) => {
  const [state, setState] = useState({
    checkbox: row.is_denylisted,
    istaff_id: row.istaff_id,
    loading: false,
  });

  useEffect(() => {
    setState((s) => ({
      checkbox: row.is_denylisted,
      istaff_id: row.istaff_id,
      loading: false,
    }));
  }, [row]);

  const handleToggle = (componentName) => {
    setState({
      ...state,
      [componentName]: !state[componentName],
    });
  };

  const submitSave = () => {
    setState({ ...state, loading: true });
    var newEmployee = {
      ...row,
      user: row.user ? row.user.id : null,
      is_denylisted: state.checkbox,
      istaff_id: state.istaff_id,
    };
    axios
      .put(iStaffBaseURL + "/handler/employees/" + row.id, newEmployee, {
        headers: { Authorization: "Token " + userToken },
        timeout: axiosTimeout,
      })
      .then((response) => {
        notify("Success", "User details updated.", "success");
        dispatch({
          type: "FETCH_EMPLOYEES",
          employees: [
            ...employees.filter((e) => e.id !== row.id),
            { ...newEmployee, user: row.user },
          ],
        });
      })
      .catch((error) => {
        notify(
          "Error",
          "User details failed to be updated. Please try again",
          "danger"
        );
      })
      .finally(() => {
        setState({ ...state, loading: false });
      });
  };

  return (
    <TableRow
      hover
      role="checkbox"
      aria-checked={state.isSelected}
      tabIndex={-1}
      key={row.id}
    >
      <Tooltip title={toolTipContactDetails(row.user)} className="noPress">
        <TableCell
          component="th"
          id={labelId}
          scope="row"
          padding="none"
          align="center"
        >
          {row.user.first_name} {row.user.last_name}
        </TableCell>
      </Tooltip>

      <TableCell align="center">{toolTipContactDetails(row.user)}</TableCell>

      <TableCell align="center">
        {row.expo_push_notification_token ? (
          <CIcon
            content={freeSet.cilCheckCircle}
            color={COLORS.iStaffGreen}
            customClasses="c-sidebar-nav-icon"
          />
        ) : (
          <CIcon
            content={freeSet.cilXCircle}
            color={COLORS.errorRed}
            customClasses="c-sidebar-nav-icon"
          />
        )}
      </TableCell>

      <TableCell align="center">
        <Checkbox
          color={"default"}
          checked={state.checkbox}
          onClick={() => handleToggle("checkbox")}
        />
      </TableCell>

      <TableCell align="center" className="">
        <CInput
          value={state.istaff_id}
          onChange={(val) => {
            setState({ ...state, istaff_id: val.currentTarget.value });
          }}
        />
      </TableCell>

      <TableCell align="center" className="text-warning">
        {state.loading ? (
          <div
            class="spinner-border spinner-border-sm text-success"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        ) : (
          <button
            type="button"
            class="btn btn-success justify-self-center"
            style={{ color: COLORS.WHITE }}
            onClick={() => {
              submitSave();
            }}
          >
            Save Changes
          </button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default EmployeeTableRow;
